import { Box, Button, Card, Layer, Text } from "grommet";
import { Close, List, Table } from "grommet-icons";
import React from "react";
import BookTocModal from "./BookTocModal";

// import {BookInfo} from "../config/types";

const BookListUnit = (props: any) => {
    const listUnit = props.bookinfo;
    // console.log("book list unit", listUnit)

    const Publisher = (props: any) => {
        const { publisher } = props;
        let title_div = publisher.split("<");
        let title = title_div[0];
        let title_info = "";
        if (title_div.length > 1) {
            title_info = title_div[1].replace(">", "");
        }
        return (
            <>
                <Text size="12px" margin="1px">
                    {" "}
                    {title}
                </Text>
                {title_info !== "" && (
                    <Text margin={{ left: "5px" }} size="12px" color="grey">
                        {title_info}
                    </Text>
                )}
            </>
        );
    };
    const [openRecord, setOpenRecord] = React.useState(false);

    return (
        <>
            <Card
                width="full"
                height="full"
                align="start"
                justify="center"
                pad={{ horizontal: "10px" }}
                round="0"
                background="rgb(255,255,255,0.8)"
            >
                <Box
                    direction="row"
                    wrap
                    align="end"
                    justify="between"
                    width="full"
                >
                    {listUnit.authors !== null &&
                        listUnit.authors.length > 0 && (
                            <Text size="13px" margin={{ right: "5px" }}>
                                {listUnit.authors}.{" "}
                            </Text>
                        )}
                    <Box alignSelf="center" hoverIndicator>
                        <Text>
                            <Text
                                size="13px"
                                margin={{ right: "5px" }}
                                weight="bold"
                            >
                                {listUnit.book_title}.
                            </Text>
                            <Text size="12px" margin={{ right: "5px" }}>
                                {listUnit.numeration}.
                            </Text>
                            <Text size="11px" margin={{ right: "5px" }}>
                                {<Publisher publisher={listUnit.publisher} />}.
                            </Text>
                            <Text size="11px" margin={{ right: "5px" }}>
                                {listUnit.publish_date}.
                            </Text>
                        </Text>
                    </Box>

                    {listUnit.toc_count > 0 && (
                        <Button
                            plain
                            label={
                                <Text size="10px" color="green">
                                    ({listUnit.toc_count})
                                </Text>
                            }
                            icon={<List size="10px" color="green" />}
                            onClick={() => {
                                setOpenRecord(!openRecord);
                            }}
                            focusIndicator={false}
                        />
                    )}
                </Box>
            </Card>
            {openRecord && (
                <Layer
                    position="right"
                    onEsc={() => setOpenRecord(false)}
                    onClickOutside={() => setOpenRecord(false)}
                    modal={true}
                    responsive={true}
                >
                    <Box alignSelf="end" margin="20px">
                        <Button
                            plain
                            icon={<Close size="10px" />}
                            onClick={() => setOpenRecord(false)}
                        />
                    </Box>
                    <Box height='full' flex={false}>
                        <BookTocModal bookinfo={listUnit} />
                    </Box>
                </Layer>
            )}
        </>
    );
};

export default BookListUnit;
